// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"C2-z","colorTextValue":"D2-z","swatches":"E2-z","collapseLink":"F2-z","isCollapsed":"G2-z","dropdown":"H2-z","disabled":"I2-z"};